module.exports = __webpack_public_path__ + "static/media/earth.80da3ac8.svg";